import { useState } from "react"
import { removeCouponOrThrow } from "src/checkout/hooks/useCart"
import { setGlobalErrorMessage } from "src/components/error/state"
import { NpButton } from "src/components/np-design/components/NpButton"
import { BusyIndicator } from "src/components/unstyled/BusyIndicator"
import { genericErrorMessage } from "src/utilities/errorMessages"
import { recordError } from "src/utilities/errorReporting"

export type DeleteCouponButtonProps = {
  code: string
}

export const DeleteCouponButton = ({ code }: DeleteCouponButtonProps) => {
  const [deleting, setDeleting] = useState(false)

  if (deleting) {
    return (
      <div className="flex size-8 items-center justify-center">
        <BusyIndicator />
      </div>
    )
  }

  return (
    <NpButton
      size="xs"
      title="Entfernen"
      variant="ghost"
      iconNameLeft="close"
      color="red"
      loading={deleting}
      onClick={async () => {
        try {
          setDeleting(true)
          await removeCouponOrThrow(code)
        } catch (error) {
          recordError("Failed to remove coupon " + code, error)
          setGlobalErrorMessage(genericErrorMessage)
        } finally {
          setDeleting(false)
        }
      }}
    />
  )
}
